import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

export interface EditModeState {
  isEditMode: boolean;
  isEditModeErrorOpen: boolean;
  editModeData: {
    deliveryId: number;
  } | null;
}

const initialState: EditModeState = {
  isEditMode: false,
  isEditModeErrorOpen: false,
  editModeData: null,
};

const editModeSlice = createSlice({
  name: 'edit-mode',
  initialState,
  reducers: {
    enableEditMode(state, action: PayloadAction<{ deliveryId: number }>) {
      state.editModeData = { deliveryId: action.payload.deliveryId };
      state.isEditMode = true;
    },
    disableEditMode(state) {
      state.editModeData = null;
      state.isEditMode = false;
    },
    openEditModeError(state) {
      state.isEditModeErrorOpen = true;
    },
    closeEditModeError(state) {
      state.isEditModeErrorOpen = false;
    },
  },
});

// Actions
export const editModeActions = editModeSlice.actions;

// Selectors
export const selectIsEditMode = (state: RootState) => state.editMode.isEditMode;
export const selectEditModeData = (state: RootState) => state.editMode.editModeData;
export const selectIsEditModeErrorOpen = (state: RootState) => state.editMode.isEditModeErrorOpen;

// Reducer
export const editModeReducer = editModeSlice.reducer;
